import React from 'react';
import AppContainer from '../app-container';
import LocalizedStrings from '../../localization/strings';
import DocumentTitle from 'react-document-title';
import {isEnglish} from '../../localization/language-cookie';
import HtmlRenderer from '../../components/html-renderer';
export default class RegulationsPageContainer extends AppContainer {
    getContent(){
      return isEnglish() ? window.CARE_CONFIG.settings.regulations_en : window.CARE_CONFIG.settings.regulations;
    }
    render() {
        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.regulations)}>
                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{LocalizedStrings.regulations}</span>
                        </h1>
                        <div className="post-body">
                            <HtmlRenderer html={this.getContent()}/>
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}



// WEBPACK FOOTER //
// ./src/js/containers/pages/regulations-page-container.js